var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"page-footer-inner"},[_vm._v(" 2019 - "+_vm._s(new Date().getFullYear())+" © | "),_c('a',{attrs:{"href":"https://www.alfiobardolla.com/","target":"_blank"}},[_vm._v("Alfio\n    Bardolla Training Group")]),_vm._v(" | v. 3.1.0\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }